import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAddContactContentMutation, useUpdateContactContentMutation, useGetContactContentByIdQuery } from "../../../Services/ContactAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

function AddStock() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        phone: "",
        email: "",
        address: "",
        facebook: "",
        twitter: "",
        instagram: "",
        youtube: "",
        content: ""
    });

    const [errors, setErrors] = useState({});

    const [updateStock, { isLoading: updateLoading }] = useUpdateContactContentMutation();
    const [addStock, { isLoading: addLoading }] = useAddContactContentMutation();
    const { data: contentDetail, isLoading: loadingContent, error, refetch: refetchcontentDetail } = useGetContactContentByIdQuery();
    const [apiError, setApiError] = useState(null);

    useEffect(() => {
        refetchcontentDetail();
    }, [refetchcontentDetail]);

    useEffect(() => {
        if (contentDetail?.data?.length > 0) {
            const existingData = contentDetail.data[0];
            setFormData({
                phone: existingData.phone || "",
                email: existingData.email || "",
                address: existingData.address || "",
                facebook: existingData.facebook || "",
                twitter: existingData.twitter || "",
                instagram: existingData.instagram || "",
                youtube: existingData.youtube || "",
                content: existingData.content || ""
            });
        }
    }, [contentDetail]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" })); // Clear error when user types
    };

    const validateForm = () => {
        const newErrors = {};
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const domainOnlyPattern = /^(?!https?:\/\/)[\w-]+\.[a-z]{2,}(\S*)?$/i;

        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!emailPattern.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        // if (formData.website && !urlPattern.test(formData.website)) {
        //     newErrors.website = "Invalid website URL";
        // }

        ["facebook", "twitter", "instagram", "youtube"].forEach(field => {
            if (formData[field] && !domainOnlyPattern.test(formData[field])) {
                newErrors[field] = `Enter a valid domain like x.com (no https) for ${field}`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const formDataToSend = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (value !== "") {
                    formDataToSend.append(key, value);
                }
            });

            if (contentDetail?.data?.length > 0) {
                const id = contentDetail?.data?.[0]?.id;
                await updateStock({ formData: formDataToSend, id }).unwrap();
            } else {
                await addStock({ formData: formDataToSend }).unwrap();
            }
            alert("Contact Updated Successfully")
            navigate("/contact-add");
        } catch (error) {
            console.error("Error submitting form:", error);
            setApiError(error.data?.message || "Something went wrong");
            setTimeout(() => {
                setApiError("");
            }, 3000);
        }
    };

    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Add Contact Details  <div className="tooltip-container">
                <FontAwesomeIcon
                    icon={faCircleInfo}
                    className="text-warning mx-2"
                    style={{ cursor: "pointer" }}
                />
                <div className="tooltip">The data will be displayed in the Contact and Footer sections.</div>
            </div></h3>
            {/* <div className="breadcrum mb-4">
                <p>
                    <FontAwesomeIcon icon={faAngleLeft} className="mx-2" />
                    <Link to="/about"><span>Back</span></Link>
                </p>
            </div> */}
            <div className="content-wrapper">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        {Object.keys(formData).map((key) => (
                            <div className="col-md-6 col-sm-12 col-lg-6" key={key}>
                                <div className="mb-4 text-start">
                                    <label htmlFor={key} className="form-label">
                                        {key === "content"
                                            ? "Reach Out to Us Content" // Custom label for 'content' field
                                            : key
                                                .replace(/_/g, ' ') // Replace underscores with spaces
                                                .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
                                                .replace(/\b(Facebook|Instagram|Twitter|Youtube)\b/, '$1 Link') // Add 'Link' for social media
                                        }
                                    </label>

                                    {key === "address" || key === "content" ? (
                                        <textarea
                                            className="form-control"
                                            id={key}
                                            name={key}
                                            placeholder={`Enter ${key.replace(/_/g, ' ')}`}
                                            value={formData[key]}
                                            onChange={handleChange}
                                        ></textarea>
                                    ) : (
                                        <input
                                            type="text"
                                            className="form-control"
                                            id={key}
                                            name={key}
                                            placeholder={`Enter ${key.replace(/_/g, ' ')}`}
                                            value={formData[key]}
                                            onChange={handleChange}
                                        />
                                    )}
                                    {errors[key] && <p className="text-danger">{errors[key]}</p>}
                                </div>
                            </div>
                        ))}
                    </div>
                    {apiError && <p className="text-danger text-center">{apiError}</p>}
                    <button type="submit" className="btn btn-primary" disabled={addLoading || updateLoading}>
                        {addLoading || updateLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddStock;
